<template>
  <div class="card">
    <div class="card-header">
      <div class="card-title d-flex align-items-center">
        <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
          <inline-svg src="media/icons/duotune/general/gen046.svg" />
        </span>
        <h3 class="fw-bold m-0 text-gray-800">Ajuda</h3>
      </div>
      <div
        v-if="this.modal === true"
        class="btn btn-icon btn-sm btn-active-light-primary mt-6"
        data-bs-dismiss="modal"
        @click="this.$emit('fecharAjuda', false)"
      >
        <span class="svg-icon svg-icon-1 svg-icon lh-0">
          <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
        </span>
      </div>
    </div>
    <div class="card-body p-0">
      <div
        v-if="this.errosValidacaoGeral.length"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              <ul>
                <li v-for="value in this.errosValidacaoGeral" :key="value">
                  {{ value }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div
            v-if="!this.showFilter"
            class="d-flex align-items-center position-relative my-1"
          >
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisarAjuda"
              v-model="tableData.search"
              @input="onSearch($event.target.value)"
              class="form-control form-control-solid w-250px ps-15"
              placeholder="Pesquisar Ajuda"
              @keydown="keydownPesquisa"
              autocomplete="off"
              type="search"
            />
          </div>
        </div>
        <div class="card-toolbar">
          <div
            v-if="checkedAjuda.length === 0"
            class="d-flex justify-content-end"
            data-kt-customer-table-toolbar="base"
          >
            <button
              v-if="this.consultarAjudaCategoria"
              @click="this.modalAjudaCategorias(true)"
              type="button"
              class="btn btn-sm btn-light-primary svg-icon-white"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg src="media/icons/duotune/art/art002.svg" />
                Categorias
              </span>
            </button>
            <router-link
              v-if="this.adicionar && this.modal === false"
              to="/principal/ajuda/editar"
              class="btn btn-sm btn-primary ms-2"
              ><span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/general/gen041.svg" /></span
              >Adicionar</router-link
            >
          </div>
          <div
            v-else
            class="d-flex justify-content-end align-items-center"
            data-kt-customer-table-toolbar="selected"
          >
            <div class="fw-bolder me-5">
              <span class="me-2">{{ checkedAjuda.length }}</span
              >Selecionado(s)
            </div>
            <button
              v-if="this.excluir && this.modal === false"
              type="button"
              class="btn btn-sm btn-danger"
              @click="deleteSelecionados()"
            >
              Excluír Selecionado(s)
            </button>
          </div>
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="table"
          :table-header="tableHeader"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          empty-table-text="Nenhuma ajuda encontrada"
          v-on:checked-rows="checkedAjuda = $event"
          :colors="true"
          v-on:double-click="selecionarRegistro($event)"
          v-on:current-row-selected="currentRow = $event"
          :current-row="currentRow"
          @showFilter="this.showFilter = $event"
        >
          <template v-slot:cell-checkbox="{ row: ajuda }">
            <div
              class="form-check form-check-sm form-check-custom form-check-solid"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="ajuda.id"
                v-model="checkedAjuda"
              />
            </div>
          </template>
          <template v-slot:cell-id="{ row: ajuda }">
            {{ ajuda.id }}
          </template>
          <template v-slot:cell-imagem="{ row: ajuda }">
            <div
              v-if="ajuda.imagem ? ajuda.imagem : ''"
              class="symbol symbol-50px"
            >
              <div
                class="symbol-label fs-2 fw-bold bg-light-dark"
                :style="{
                  'background-image': `url(${
                    this.$utils.getUrl() + ajuda.imagem
                  })`,
                }"
              ></div>
            </div>
            <div v-else class="symbol symbol-50px">
              <div :class="['symbol-label fs-2 fw-bold ' + ajuda.color]">
                {{
                  ajuda.descricao
                    ? ajuda.descricao.substring(0, 1).toUpperCase()
                    : ""
                }}
              </div>
            </div>
          </template>
          <template v-slot:cell-descricao="{ row: ajuda }">
            <div class="min-w-150px">{{ ajuda.descricao }}</div>
          </template>
          <template v-slot:cell-assunto="{ row: ajuda }">
            <div class="min-w-150px">{{ ajuda.assunto }}</div>
          </template>
          <template v-slot:cell-AjudaCategoriaDescricao="{ row: ajuda }">
            <div>
              {{
                ajuda.AjudaCategoria && ajuda.AjudaCategoria.descricao
                  ? ajuda.AjudaCategoria.descricao
                  : ""
              }}
            </div>
          </template>
          <template v-slot:cell-AjudaModuloCategoriaDescricao="{ row: ajuda }">
            <div>
              {{
                ajuda.AjudaModuloCategoria &&
                ajuda.AjudaModuloCategoria.descricao
                  ? ajuda.AjudaModuloCategoria.descricao
                  : ""
              }}
            </div>
          </template>
          <template v-slot:cell-createdAt="{ row: ajuda }">
            {{ this.$utils.formatarData(ajuda.createdAt) }}
          </template>
          <template v-slot:cell-updatedAt="{ row: ajuda }">
            {{ this.$utils.formatarData(ajuda.updatedAt) }}
          </template>
          <template v-slot:cell-acoes="{ row: ajuda }">
            <div class="min-w-200px">
              <button
                class="btn btn-sm btn-light-primary me-2"
                @click="selecionarRegistro(ajuda)"
              >
                Abrir
              </button>
              <button
                v-if="this.modal === false"
                class="btn btn-sm btn-light btn-active-light-primary"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-flip="top-end"
              >
                Ações
                <span class="svg-icon svg-icon-5 m-0">
                  <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
                </span>
              </button>
              <div
                v-if="this.editar || this.excluir"
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                data-kt-menu="true"
              >
                <div v-if="this.editar" class="menu-item px-3">
                  <a @click="editarRegistro(ajuda.id)" class="menu-link px-3"
                    >Editar</a
                  >
                </div>
                <div v-if="this.excluir" class="menu-item px-3">
                  <a @click="removerRegistro(ajuda.id)" class="menu-link px-3"
                    >Excluír</a
                  >
                </div>
              </div>
            </div>
          </template>
        </Datatable>
      </div>
    </div>
  </div>
  <AjudaCategoriaModal
    v-if="exibirAjudaCategorias"
    :showSelection="false"
    @exibirModalAjudaCategorias="modalAjudaCategorias"
  ></AjudaCategoriaModal>
  <ExibirAjudaModal
    v-if="exibirAjuda"
    :ajuda="this.ajuda"
    @cancelarExibirAjuda="modalExibirAjuda"
  ></ExibirAjudaModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import AjudaCategoriaModal from "@/views/ajuda/AjudaCategoriaModal.vue";
import ExibirAjudaModal from "@/views/ajuda/ExibirAjudaModal.vue";
import { hideModalId, getOrCreateInstanceModal } from "@/core/helpers/dom";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: ["selecionarAjuda", "fecharAjuda"],
  components: {
    Datatable,
    AjudaCategoriaModal,
    ExibirAjudaModal,
  },
  props: {
    modal: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    modalAjudaCategorias(exibir) {
      this.exibirAjudaCategorias = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_ajuda_categorias_consultar");
        }, 100);
      }
    },
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(descricao, '" +
          pesquisa +
          "') or contains(assunto, '" +
          pesquisa +
          "') or contains(tags, '" +
          pesquisa +
          "') or contains(AjudaCategoria/descricao, '" +
          pesquisa +
          "') or contains(AjudaModuloCategoria/descricao, '" +
          pesquisa +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    async deleteSelecionados() {
      var alert = await Swal.fire({
        text: "Deseja remover os registros selecionados?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.errosValidacaoGeral = [];
        this.excluiuCadastro = true;
        this.$refs.table.setLoading(true);
        for (var i = 0; i < this.checkedAjuda.length; i++) {
          await this.excluirAjuda(this.checkedAjuda[i]);
        }
        if (this.excluiuCadastro === true) {
          toast.success("Ajuda excluída com sucesso!", { timeout: 3000 });
        }
        this.$refs.table.load();
      }
    },
    async removerRegistro(id) {
      var alert = await Swal.fire({
        text: "Deseja remover o registro?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.errosValidacaoGeral = [];
        this.excluiuCadastro = true;
        this.$refs.table.setLoading(true);
        await this.excluirAjuda(id);
        if (this.excluiuCadastro === true) {
          toast.success("Ajuda excluída com sucesso!", { timeout: 3000 });
        }
        this.$refs.table.load();
      }
    },
    async excluirAjuda(id) {
      try {
        await this.$store.dispatch("ajuda/deleteAjuda", id);
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },
    editarRegistro(id) {
      this.$router.push("/principal/ajuda/editar/" + id);
    },
    async selecionarRegistro(ajuda) {
      try {
        var ret = await this.$store.dispatch("ajuda/getAjuda", ajuda.id);
        if (ret.Success === true) {
          var ajudaData = ret.Data;
          ajudaData.conteudo = ajudaData.conteudo.replace(
            new RegExp("/uploads/Ajuda", "g"),
            this.$utils.getUrl() + "/uploads/Ajuda"
          );

          if (this.modal === true) {
            this.$emit("selecionarAjuda", ajudaData);
          } else {
            this.ajuda = ajudaData;
            this.modalExibirAjuda(true);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    modalExibirAjuda(exibir) {
      this.exibirAjuda = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_exibir_ajuda");
        }, 100);
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async verificarRestricoes() {
      if (this.user.User.TipoUsuario.Restricao != null) {
        this.user.User.TipoUsuario.Restricao.find((element) => {
          if (element.regra === "Permitir.Ajuda.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.Ajuda.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.Ajuda.Excluir") {
            this.excluir = true;
          }

          if (element.regra === "Permitir.AjudaCategoria.Consultar") {
            this.consultarAjudaCategoria = true;
          }
        });
      }
    },
    async keydownPesquisa(e) {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        this.currentRow -= 1;
        if (this.currentRow < 0) {
          this.currentRow = 0;
        }
        this.$refs.table.setCurrentRow(this.currentRow);
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        this.currentRow += 1;
        this.$refs.table.setCurrentRow(this.currentRow);
      } else if (e.key === "Enter") {
        e.preventDefault();
        let ajuda = this.$refs.table.getCurrentItemIndex(this.currentRow);
        this.selecionarRegistro(ajuda);
      }
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    setTimeout(() => {
      this.nextFocus("txtPesquisarAjuda");
    }, 800);
  },
  data() {
    return {
      ajuda: null,
      exibirAjuda: false,
      exibirAjudaCategorias: false,
      consultarAjudaCategoria: false,
      showFilter: false,
      adicionar: false,
      editar: false,
      excluir: false,
      checkedAjuda: [],
      currentRow: 0,
      errosValidacaoGeral: [],
      excluiuCadastro: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          key: "imagem",
          sortable: false,
        },
        {
          name: "Descrição",
          key: "descricao",
          sortable: true,
        },
        {
          name: "Assunto",
          key: "assunto",
          sortable: true,
        },
        {
          name: "Categoria",
          key: "AjudaCategoriaDescricao",
          sortingField: "AjudaCategoria/descricao",
          sortable: true,
        },
        {
          name: "Módulo",
          key: "AjudaModuloCategoriaDescricao",
          sortingField: "AjudaModuloCategoria/descricao",
          sortable: true,
        },
        {
          name: "Emissão",
          key: "createdAt",
          sortable: true,
        },
        {
          name: "Alteração",
          key: "updatedAt",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "ajuda/getAjudaOData",
        selectOData:
          "?$select=id,descricao,assunto,createdAt,updatedAt,imagem&$expand=AjudaCategoria($select=descricao),AjudaModuloCategoria($select=descricao)",
        filterOData: "",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
